require('../filter-editor-modal.component.scss');


class GraphicObjectsFilterEditorController {
  constructor($scope, CurrentModelService) {
    this.$scope = $scope;
    this.CurrentModelService = CurrentModelService;
  }

  $onInit() {
    let $scope = this.$scope;
    let $ctrl = $scope.$ctrl;

    $ctrl.filter = $scope.filter;
    $ctrl.type_selection_error = '';

    $scope.$on('filter-validation', (event, args) => {
      if (!event.defaultPrevented) {
        this.checkFilter();
      }
    });
  }

  checkFilter() {
    let $scope = this.$scope;
    let $ctrl = $scope.$ctrl;

    if ($scope.filter.do_scan && !$scope.filter.graphic_objects_type) {
      $ctrl.type_selection_error = gettext('Необходимо выбрать тип объекта');

      if (!$scope.errorMessage.error) {
        $scope.errorMessage.error = true;
        $scope.errorMessage.text = $ctrl.type_selection_error;
      }
    } else {
      $ctrl.type_selection_error = '';
    }
  }
}

export function GraphicObjectsFilterEditorDirective() {
  return {
    restrict: 'E',
    template: require('./graphicobjects-filter-editor.component.html'),
    controller: GraphicObjectsFilterEditorController,
    controllerAs: '$ctrl',
  }
}



// WEBPACK FOOTER //
// ./src/filter/editor/spec-forms/graphicobjects-filter-editor.component.js